module.exports = __webpack_public_path__ + "img/500.9c8967ed.png";